import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { ApidataService } from "src/app/services/apidata.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HrUserAuthenticationService } from "../core/storage/authentication-hruser.service";
import { ShowregisterloginService } from "src/app/services/showregisterlogin.service";
import { AppSettings } from "../app.setting";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { StorageService } from "../core/storage/storage.service";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.css"],
})
export class PagesComponent implements OnInit {
  public isShow = true;
  isShow1 = false;
  public firstName: any;
  public displayName: string = "";
  public isLoggedIn: boolean = false;
  public dashboardUrl: string = "";
  public type_user: any;
  settings: any;
  showBackToTop = false;
  showButton: boolean;
  constructor( private apicall:ApidataService, 
    private hrUserAuthenticationService: HrUserAuthenticationService,
    private hr_registrationS: ShowregisterloginService,
    private router: Router,
    private route: ActivatedRoute,
    public appSettings: AppSettings,
    private storageService: StorageService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.checkLoginStatus();
  }

  checkLoginStatus() {
    const currentUser = this.storageService.secureStorage.getItem("currentUser");
    const currentUserLogin = this.storageService.secureStorage.getItem("currentUserLogin");
    const userType = this.storageService.secureStorage.getItem("user_type");
    const typeUser = this.storageService.secureStorage.getItem("type_user");
    const userId = this.storageService.secureStorage.getItem("userId") ||
                   this.storageService.secureStorage.getItem("adminId") ||
                   this.storageService.secureStorage.getItem("hrUserId");

    this.isLoggedIn = !!(currentUser || currentUserLogin || userType || typeUser || userId);
    this.type_user = userType || typeUser || "";

    const fName = this.storageService.secureStorage.getItem("firstName") ||
                  this.storageService.secureStorage.getItem("first_name");
    const lName = this.storageService.secureStorage.getItem("lastName") ||
                  this.storageService.secureStorage.getItem("last_name");
    const fullName = this.storageService.secureStorage.getItem("name");
    const userName = this.storageService.secureStorage.getItem("username");
    const clientName = this.storageService.secureStorage.getItem("ClientfirstName");
    const roleName = this.storageService.secureStorage.getItem("roleadminfirstName") ||
                     this.storageService.secureStorage.getItem("roleHRfirstName") ||
                     this.storageService.secureStorage.getItem("roleManagerfirstName") ||
                     this.storageService.secureStorage.getItem("roleFinancefirstName") ||
                     this.storageService.secureStorage.getItem("roleReceptionistfirstName");

    if (fName) {
      this.firstName = fName;
      this.displayName = lName ? `${fName} ${lName}` : fName;
    } else if (fullName) {
      this.firstName = fullName;
      this.displayName = fullName;
    } else if (userName) {
      this.firstName = userName;
      this.displayName = userName;
    } else if (clientName) {
      this.firstName = clientName;
      this.displayName = clientName;
    } else if (roleName) {
      this.firstName = roleName;
      this.displayName = roleName;
    } else if (this.type_user) {
      this.firstName = this.type_user.charAt(0).toUpperCase() + this.type_user.slice(1);
      this.displayName = this.firstName;
    } else {
      this.firstName = "User";
      this.displayName = "User";
    }

    if (this.type_user === "employee" || currentUser === "EmployeeLogin") {
      this.dashboardUrl = "/layout/dashboard/employee";
    } else if (this.type_user === "client" || currentUser === "ClientLogin") {
      this.dashboardUrl = "/layout/dashboard/client";
    } else if (this.type_user === "affiliate" || currentUser === "AffiliateLogin") {
      this.dashboardUrl = "/layout/dashboard/affiliate";
    } else if (this.type_user === "mainadmin" || currentUser === "MainAdminLogin") {
      this.dashboardUrl = "/layout/dashboard/mainadmin";
    } else if (this.type_user === "hrUser" || currentUserLogin === "HrUserLogin") {
      this.dashboardUrl = "/products";
    } else if (this.isLoggedIn) {
      this.dashboardUrl = "/layout/dashboard/admin";
    }

    this.isShow = !this.isLoggedIn;
    this.isShow1 = this.isLoggedIn;
  }

  logout() {
    try {
      this.hrUserAuthenticationService.logout();
    } catch (e) {}
    try {
      this.storageService.secureStorage.clear();
      sessionStorage.clear();
      localStorage.clear();
    } catch (e) {}
    this.isLoggedIn = false;
    this.isShow = true;
    this.isShow1 = false;
    window.location.replace("");
  }
  public scrollToTop() {
    this.document.body.scrollTop = 0;
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    const scrollTopHeight = document.body.scrollTop || 0;

    if (scrollTopHeight > 200) {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  visible() {
    this.isShow = !this.isLoggedIn;
    this.isShow1 = this.isLoggedIn;
  }

  showPage(value) {
    if (value === "register") {
      this.hr_registrationS.showPage("signUp");
      this.router.navigate(["/register"], {
        queryParams: {
          signUp: "signUp",
        },
      });
    } else if (value === "login") {
      this.hr_registrationS.showPage("signIn");
      this.router.navigate(["/register"], {
        queryParams: {
          signUp: "signIn",
        },
      });
    }
  }

  getFreeTrial() {
    if (this.isLoggedIn) {
      this.router.navigate(["/checkouts"]);
    } else {
      this.router.navigate(["/register"]);
    }
  }
}
